import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ServiceAppointment as Appointment, WorkOrder } from '@quorum/models/xs-resource';
import { MediaStateService } from '@quorum/sha-media';
import { MediaGalleryDialogComponent } from 'libs/sha-components-ng-ui/src/lib/media-gallery-dialog/media-gallery-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { filter, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'svc-work-order-header',
  templateUrl: './work-order-header.component.html',
  styleUrls: ['./work-order-header.component.scss'],
})
export class WorkOrderHeaderComponent implements OnInit, OnDestroy {
  @Input() transactions$: Observable<{
    appointment: Appointment;
    workOrder: WorkOrder;
  }>;

  @Input() toggleTireFinderWidgetValue: boolean;
  @Output() toggleTireFinder: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  destroy$ = new Subject<void>();
  systemControl$: Observable<{ [key: string]: any }>;

  constructor(
    private mediaStateService: MediaStateService,
    public dialog: MatDialog,
    private authenticationStateService: AuthenticationStateService,
    private systemControlStateService: SystemControlStateService
  ) {}

  ngOnInit(): void {
    this.authenticationStateService
      .selectAuthenticatedEmployee()
      .pipe(
        filter((currentUser) => currentUser != null),
        takeUntil(this.destroy$),
        tap((currentUser) => {
          this.systemControl$ = this.systemControlStateService.getSystemControlValues(
            ['CL_GM_TIRE_CENTRAL_WIDGET'],
            currentUser.rooftopId
          );
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  mediaGalleryDialog(vehicleId: number) {
    this.mediaStateService.loadMediaForVehicle(vehicleId);
    const dialogData: any = {
      media$: this.mediaStateService.getVehicleMedia(),
      showFilter: true,
    };
    this.dialog.open(MediaGalleryDialogComponent, {
      width: '800px',
      height: '600px',
      data: dialogData,
      disableClose: true,
    });
  }

  toggleTireFinderWidget(toggleTireFinderWidgetValue: boolean) {
    this.toggleTireFinderWidgetValue = !toggleTireFinderWidgetValue;
    this.toggleTireFinder.emit(!toggleTireFinderWidgetValue);
  }
}
